import { createApp } from 'vue'
import App from './App.vue'
import vuetify from '../common/plugins/vuetify'
import store from '../store/index.js'
import '../style.css'
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.material.blue.light.compact.css'

const apiService = {}

var app = createApp(App)

app.config.globalProperties.apiService = apiService

app.use(vuetify).use(store).mount('#tsid-direct-login')
